import { render, staticRenderFns } from "./AnnouncementBarForm.vue?vue&type=template&id=88a880fa"
import script from "./AnnouncementBarForm.vue?vue&type=script&lang=js"
export * from "./AnnouncementBarForm.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBarForm.vue?vue&type=style&index=0&id=88a880fa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports